export class Docks {
    public id: number;
    public dock: string;
    public descCompDock: string;
    public dunsDock: string;
    public ptoEmision: string;
    public balanza: string;
    public fecCreacion: Date | null = new Date();
    public usrCreacion: string;
    public fecModif: Date | null = new Date();
    public usrModif: string;
    public estado: boolean;
    public added: boolean;
    public edit: boolean;
    public duplicateDock: boolean;
    public duplicateExist: boolean;

  static transformDockData(data: any): Docks {
    let dockData = new Docks();
    dockData.id = data.id;
    dockData.dock = data.dock;
    dockData.descCompDock = data.descCompDock;
    dockData.dunsDock = data.dunsDock;
    dockData.ptoEmision = data.ptoEmision;
    dockData.balanza = data.balanza;
    dockData.fecCreacion = data.fecCreacion != null ? new Date(data.fecCreacion) : null;
    dockData.usrCreacion = data.usrCreacion;
    dockData.fecModif = data.fecModif != null ? new Date(data.fecModif) : null;
    dockData.usrModif = data.usrModif;
    dockData.estado = data.estado;
    dockData.added = data.added;
    dockData.edit = data.edit;
    dockData.duplicateDock = data.duplicateDock;
    dockData.duplicateExist = data.duplicateExist;

    return dockData;
  }
}
